import { validationIsEqual } from '../status';
import { validateAlphaNumericString, validateAlphaNumericStringAllowingOnlyNumbers, validateAlphaString, validateName, validateNumber, validateNumericString } from '@om/validation';
import {
    REG_NUMBER_SET_VALUE,
    CHASIS_NUMBER_SET_VALUE,
    TIN_NUMBER_SET_VALUE,
    setChasisNoValid,
    setRegistrationNoValid,
    setTinNumberValid,
    FUEL_TYPE_SET_VALUE,
    setFuelTypeValid,
} from '../../../actions/motorPrivateRW/carDetails';

let prevValidationAction = null;

function validateAlphanumeric(str) {
  if (!str || str.length < 1) return 'Input cannot be empty.';
  
  const hasLetters = /[a-zA-Z]/.test(str);
  const hasNumbers = /[0-9]/.test(str);
  const onlyLettersOrNumbers = /^[a-zA-Z0-9]+$/.test(str);

  if (!onlyLettersOrNumbers) {
    return 'Input must contain only letters and numbers.';
  }

  if (!hasLetters || !hasNumbers) {
    return 'Input must contain both letters and numbers.';
  }

  return null; // Valid
}

export const carDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case REG_NUMBER_SET_VALUE:
                error = validateAlphanumeric(action.value, {
                    subject: 'Vehicle plate number',
                });
                return setRegistrationNoValid(error);

            case CHASIS_NUMBER_SET_VALUE:
                error = validateAlphaNumericString(action.value, {
                    subject: 'Chassis number',
                });
                return setChasisNoValid(error);

            case TIN_NUMBER_SET_VALUE:
                error = validateNumericString(action.value, {
                    subject: 'TIN Number',
                    max: 9,
                    min: 9
                });
                return setTinNumberValid(error);

            case FUEL_TYPE_SET_VALUE:
                error = validateAlphaString(action.value, {
                    subject: 'Fuel type',
                });
                return setFuelTypeValid(error);
            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
